import React, { useState, useEffect, useContext } from "react";
import "./Switch_Banner.css";
import Common_Btn from "../../../common/common-btn/Common_Btn";
import Solar_Modal from "../../../common/solar-modal/Solar_Modal";
import { GetStarteds } from "../../../../utils/apis/blog/Blog";
import { Context } from "../../../../utils/context";
import { IDS } from "../../../../utils/common";

const Switch_Banner = () => {
  const [showModal, setShowModal] = useState(false);

  const { IMG_URL } = useContext(Context);
  
    const [getStart, setGetStart] = useState([]);
  
    const getStarted = async () => {
      const res = await GetStarteds();
  
      if (res?.success) {
        setGetStart(res?.data?.data?.[0] || []);
      }
    };
  
    useEffect(() => {
      getStarted();
    }, []);

  return (
    <>
      <section className="Switch_Banner">
        <div className="row">
          <div className="col-lg-7 col-md-7 p-0">
            <div className="Switch_Banner_content_holder">
              <h5 className="Switch_Banner_header">
                Ready to <span className="make_span"> make the</span>{" "}
                <span className="switch"> Switch?</span>{" "}
              </h5>
              <p className="Switch_Banner_text">
                Get a free solar consultation and discover how much you can save
                by powering your home with the sun.
              </p>

              <div
                className="Switch_Banner_btn_holder"
                onClick={() => setShowModal(true)}
              >
                <Common_Btn text={"Get Started"} />
              </div>
            </div>
          </div>

          <div className="col-lg-5 col-md-5 p-0">
            <div className="Switch_Banner_img_holder">
              <img
                // src="/assets/images/blogs/woman.png"
                src={IDS?.IMG_URL + getStart?.image}
                alt=""
                className="Switch_Banner_img"
              />
            </div>
          </div>
        </div>

        <Solar_Modal show={showModal} handleClose={() => setShowModal(false)} />
      </section>
    </>
  );
};

export default Switch_Banner;
